import { useNavigate } from "react-router";
import { Block } from "../../../../Components/Block/Block";
import { Container } from "../../../../components/Container/Container";
import { useFetchData } from "../../../../services/useFetchData.service";
import { useUserData } from "../../../../providers/UserDataProvider/useUserData";
import { Spinner } from "../../../../components/Spinner/Spinner";
import { Image } from "../../../../components/Image/Image";
import styles from './Email.module.scss';
import { Title } from "../../../../components/Title/Title";
import { useEffect, useState } from "react";
import cn from "classnames";
import { isEmailValid } from "../../../../services/isEmailValid";
import { InputConfirmIcon } from "../../../../components/InputConfirmIcon/InputConfirmIcon";
import { ContinueButton } from "../../../../components/ContinueButton/ContinueButton";
import { fbCompleteRegistration } from "../../../../utils/FacebookEvents";
import { ampRegistration, ampScreenCompleted } from "../../../../utils/AmplitudeEvents";
import { getReferpulseAttribution, getReferpulseBaseUrl } from "../../../../services/referpulseAttribution";
export const Email = ({dataUrl ='/Data/Email.json',theme})=>{
  // const emailDomains = ["gmail.com", "yahoo.com", "outlook.com", "icloud.com"];
  const [suggestions, setSuggestions] = useState([]);
  const [email, setEmail] = useState("");
  const [emailFocused, setEmailFocused] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const { userData, setUserData } = useUserData();
  const navigate = useNavigate();
  const { data } = useFetchData(dataUrl);
  const emailDomains = data?.domains || null;
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);

  useEffect(() => {
    const [local, domainPart] = email.split("@");
    if(!emailDomains) return;

    if (email.includes("@")) {
      const matched = emailDomains
        .filter(d => d.startsWith(domainPart.toLowerCase()))
        .map(d => `${local}@${d}`)
        .filter(full => full !== email);
  
      setSuggestions(matched.slice(0, 4));
    } else {
      setSuggestions([]);
    }
  }, [email]);
  if (!data) {
    return <Spinner />;
  }
  const formValid =
    email &&
    isEmailValid(email);
  
  const { slug,image, title, placeholder,placeholderError,icon, secureText,button,nextPage } = data;
  const handleSubmit = async () => {
    if (!formValid) return;
    setUserData({ ...userData, email });
    const referpulseAttribution = getReferpulseAttribution();
    if (referpulseAttribution?.ref) {
      try {
        await fetch(`${getReferpulseBaseUrl()}/attribution.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            ...referpulseAttribution,
          }),
        });
      } catch {}
    }
    fbCompleteRegistration();
    ampScreenCompleted(slug,title || null)
    ampRegistration();
    navigate(nextPage || "/paywall/");
  };
  return (
    <>
      <Block>
        <Container>
          <div className={styles.wrapper}>
            {image && <Image src={image} className={styles.image}/>}
            {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }}/>}
            <label className={cn(
              styles.field,
              (emailFocused || email) && styles.focus
            )}>
              <div className={cn(
                styles.placeholder,
                (emailTouched && email && !isEmailValid(email)) && styles.error
              )}>
                {(emailTouched && email && !isEmailValid(email))
                  ? placeholderError
                  : placeholder}
              </div>
              <input
                className={cn(
                  styles.input
                )}
                type="email"
                value={email}
                onFocus={() => setEmailFocused(true)}
                onBlur={() => { setEmailFocused(false); setEmailTouched(true); setTimeout(() => setSuggestions([]), 100); }}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
              {emailTouched && (
                email
                  ? (isEmailValid(email) ? InputConfirmIcon(true) : InputConfirmIcon(false))
                  : InputConfirmIcon(false)
              )}
              {suggestions.length > 0 && (
                <ul className={styles.suggestions}>
                  {suggestions.map((item, i) => (
                    <li key={i} onClick={() =>{
                      setEmail(item);
                      setSuggestions([]);
                    }} 
                    className={styles.suggestion}>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </label>
            {secureText && 
            <div className={styles.secure}>
              <Image src={icon} className={styles.secureIcon}/>
              <span className={styles.secureText} dangerouslySetInnerHTML={{ __html:secureText }}/>
            </div>
            }
            <ContinueButton
              status={formValid ? "active" : "disabled"}
              disabled={!formValid}
              onClick={()=>{
                formValid && handleSubmit();
              }}
              className={styles.button}
            >
              {button || "Explore results"}
            </ContinueButton>
          </div>
        </Container>
      </Block>
    </>
  )
}
